export function NotFoundPage() {
  return <h1 className="text-6xl">404 not found</h1>;
}
